"use client";

import { Command } from "cmdk";

export function CommandEmpty({ title }: { title: string }) {
	return <Command.Empty>{title}</Command.Empty>;
}
